"use strict";
/**
 * The order page's positions for one poll: the primary and its parallel legs,
 * in one POST /positions, each with how far to trust it
 * (ai/POSITION_CACHE_PLAN.md §5). The legacy Polymarket venue keeps its own
 * read; it has no server cache.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.readOrderPagePositions = readOrderPagePositions;
const positions_1 = require("../api/positions");
const positions_2 = require("../../shared/positions");
const positions_3 = require("./positions");
const isCachedVenue = (venue) => positions_2.POSITION_VENUES.includes(venue);
function query(venue, marketId, novigOutcomeIds) {
    return { venue, marketId, ...(novigOutcomeIds ? { novigOutcomeIds } : {}) };
}
function positionData(answer) {
    if (!answer.position)
        return null;
    const { yes, no } = answer.position;
    return {
        ticker: answer.marketId,
        yes_quantity: yes,
        no_quantity: no,
        quantity: Math.abs(yes - no),
        market_exposure: Math.abs(yes - no),
        realized_pnl: 0,
    };
}
const stale = (answer) => !answer.position || !answer.live;
async function readOrderPagePositions(market, legs) {
    const cached = isCachedVenue(market.venue);
    const queries = [
        ...(cached ? [query(market.venue, market.id, market.novigOutcomeIds)] : []),
        ...legs.map((leg) => query(leg.venue, leg.marketId, leg.novigOutcomeIds)),
    ];
    const [legacyPrimary, answers] = await Promise.all([
        cached ? Promise.resolve(null) : (0, positions_3.fetchPolymarketPosition)(market.id, market.conditionId, market.clobTokenIds),
        queries.length > 0 ? (0, positions_1.fetchPositions)(queries) : Promise.resolve([]),
    ]);
    const legAnswers = cached ? answers.slice(1) : answers;
    const primaryAnswer = cached ? answers[0] : undefined;
    return {
        primary: primaryAnswer ? positionData(primaryAnswer) : legacyPrimary,
        primaryStale: primaryAnswer ? stale(primaryAnswer) : legacyPrimary === null,
        legs: legs.map((leg, i) => {
            const answer = legAnswers[i];
            return {
                position: answer ? positionData(answer) : null,
                invert: leg.invert ?? false,
                stale: answer ? stale(answer) : true,
            };
        }),
    };
}
